export default [
  {
      path: '/deployment-release-jobs',
      component: () => import('../pages/deployments/Index.vue'),
      children: [
        {
            path: ':id',
            name: 'deployment-release-jobs/detail',
            meta: {
                parentPath: '/deployments',
                layout: 'default',
                breadcrumb: [{ label: 'Deployments' }],
            },
            component: () => import('../pages/deployment-release-jobs/DeploymentReleaseJobDetail.vue'),
        }
      ],
  },
];
